module.exports = {
  title: 'Infinite Carousel with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2024-04-10',
  slug: 'infinite-carousel',
  tags: ['reanimated', 'gesture-handler'],
};
